export interface PricingTeaserItem {
  service: string;
  price: string;
  link: string;
}

export const pricingTeaser: PricingTeaserItem[] = [
  { service: "PPF kaitsekiletamine (osaline)", price: "alates 650 €", link: "/hinnakiri#ppf" },
  { service: "Keraamiline kaitse", price: "alates 450 €", link: "/hinnakiri#keraamika" },
  { service: "Klaaside toonimine", price: "alates 80 €", link: "/hinnakiri#toonimine" },
];
